// Share the current page: the native share sheet where the browser has one
// (navigator.share), otherwise copy the URL to the clipboard with a transient
// "copied" state. First share UI in the app — kept generic so other entity
// pages can reuse it.
import { useEffect, useState } from "react";
import { Check, Share2 } from "lucide-react";
import { useT } from "../lib/i18n";
import { Button } from "@/components/ui/button";

export function ShareButton({ title }: { title: string }) {
  const { t } = useT();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  async function share() {
    const url = window.location.href;
    if (navigator.share) {
      // Cancelling the native sheet rejects with AbortError — not an error.
      await navigator.share({ title, url }).catch(() => {});
      return;
    }
    await navigator.clipboard.writeText(url);
    setCopied(true);
  }

  return (
    <Button type="button" variant="outline" size="sm" onClick={share}>
      {copied ? <Check aria-hidden className="size-3.5" /> : <Share2 aria-hidden className="size-3.5" />}
      {copied ? t("share.copied") : t("share.button")}
    </Button>
  );
}
